import { render, staticRenderFns } from "./VgvDisplay.vue?vue&type=template&id=1e164208&"
import script from "./VgvDisplay.vue?vue&type=script&lang=js&"
export * from "./VgvDisplay.vue?vue&type=script&lang=js&"
import style0 from "./VgvDisplay.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e164208')) {
      api.createRecord('1e164208', component.options)
    } else {
      api.reload('1e164208', component.options)
    }
    module.hot.accept("./VgvDisplay.vue?vue&type=template&id=1e164208&", function () {
      api.rerender('1e164208', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/components/vgv/VgvDisplay.vue"
export default component.exports